<template>
  <div class="flex flex-column">
    <section class="wf100 subheader header_map_bg">
      <div class="container">
        <h2>توزع المنظمات في سوريا</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li>الخريطة</li>
        </ul>
      </div>
    </section>
    <div class="filter_small_screen">
      <collapse-header title_img="filter" title="بحث بحسب">
        <div class="widget">
          <div>
            <div>
              <b-form-group label="اسم المنظمة">
                <b-form-input id="basicInput" v-model="filterForm.name" />
              </b-form-group>
            </div>

            <div>
              <form-select
                id="gov"
                label="المحافظة "
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filterForm.governorate"
                ep="v2/guest/selects/governorates"
              />
            </div>
            <div>
              <form-select
                label="الشكل القانوني "
                id="legalForm"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filterForm.legal_form"
                ep="v2/guest/selects/legal-forms"
              />
            </div>
            <div class="row px-1 d-flex justify-content-between">
              <b-button variant="primary" @click="unFilter()" class=""
                >إلغاء البحث</b-button
              >
              <loader-btn
                variant="info"
                @click="filtered()"
                :loading="isFiltering"
                label="بحث"
                loadingLabel="جاري البحث ..."
                noIcon
              ></loader-btn>
            </div>
          </div>
        </div>
      </collapse-header>
    </div>
    <div class="wrapper container">
      <div class="d-flex w-100">
        <basc-card class="mx-2 sidebar w-25">
          <h6 class="mb-1">
            <feather-icon icon="FilterIcon" size="14" class="mx-25" />
            بحث بحسب
          </h6>
          <div>
            <div>
              <b-form-group label="اسم المنظمة">
                <b-form-input id="basicInput" v-model="filterForm.name" />
              </b-form-group>
            </div>

            <div>
              <form-select
                id="gov"
                label="المحافظة "
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filterForm.governorate"
                ep="v2/guest/selects/governorates"
              />
            </div>
            <div>
              <form-select
                label="الشكل القانوني "
                id="legalForm"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filterForm.legal_form"
                ep="v2/guest/selects/legal-forms"
              />
            </div>
            <div class="row px-1 d-flex justify-content-between">
              <b-button variant="primary" @click="unFilter()" class=""
                >إلغاء البحث</b-button
              >
              <loader-btn
                variant="info"
                @click="filtered()"
                :loading="isFiltering"
                label="بحث"
                loadingLabel="جاري البحث ..."
                noIcon
              ></loader-btn>
            </div>
          </div>
        </basc-card>
        <div class="main-content my-1 border_map">
          <ngo-map
            @ngoMarkerClicked="setActiveNgo"
            :ngos="ngo_list"
            class="map_"
          ></ngo-map>
        </div>
      </div>
    </div>
    <transition mode="out-in" name="slide-fade">
      <div class="map-ngo-card-wrapper" v-if="cardVisible">
        <map-ngo-card
          @close="cardVisible = false"
          :loading="loading"
          :ngo.sync="ngoData"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import ngoMap from "@/components/ngo-map.vue";
import BascCard from "../../components/BascCard.vue";
import MapNgoCard from "../../components/MapNgoCard.vue";
import { BButton, BSpinner, BFormInput, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import formSelect from "@/components/form-select";
import loaderBtn from "@/components/loader-btn";
import CollapseHeader from "../../../../@core/components/app-collapse/CollapseHeader.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    formSelect,
    ngoMap,
    BascCard,
    vSelect,
    BFormGroup,
    loaderBtn,
    CollapseHeader,
    MapNgoCard,
  },
  data() {
    return {
      filterForm: {},
      cardVisible: false,
    };
  },
  methods: {
    setActiveNgo(id) {
      this.cardVisible = true;
      this.$store.dispatch("NgoHome/NgoMap/fetchNgoData", id);
    },
    filtered() {
      this.$store.dispatch("NgoHome/NgoMap/getNgoList", {
        name: this.filterForm.name || null,
        governorate: this.filterForm.governorate || null,
        legal_form: this.filterForm.legal_form || null,
        page: "MAX",
      });
    },
    unFilter() {
      this.filterForm.name = null;
      this.filterForm.governorate = null;
      this.filterForm.legal_form = null;
    },
  },

  computed: {
    ...mapGetters("NgoHome/NgoMap", [
      "ngo_list",
      "isFiltering",
      "ngoData",
      "loading",
    ]),
  },

  created() {
    this.$store.dispatch("NgoHome/NgoMap/getNgoList", {
      name: this.filterForm.name || null,
      governorate: this.filterForm.governorate || null,
      legal_form: this.filterForm.legal_form || null,
      page: "MAX",
    });
  },
};
</script>

<style lang="scss">
.map-ngo-card-wrapper {
  width: 100%;
  padding: 0.5rem;
  position: fixed;
  bottom: -3%;
  inset-inline-start: 0%;
  z-index: 1040;
}
.filter_small_screen {
  display: none;
}
.header_map_bg {
  background: var(--warning);
}
.border_map {
  border: 1px solid #aaaaaa;
}
@media (max-width: 1030px) {
  .map_ {
    height: 300px !important;
  }
  .sidebar {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
</style>
